import { isProfileLoadedFromApi, checkNavItemAccess } from './featureFlagGuardUtils';

/**
 * Testable function for tournament route access.
 * Returns '/lms' to redirect, or undefined to allow access.
 */
export const checkTournamentsAccess = (): string | undefined => {
   return checkNavItemAccess('tournaments');
};

/**
 * Middleware to protect Tournaments route when nav item is hidden.
 */
export default defineNuxtRouteMiddleware(() => {
   if (!isProfileLoadedFromApi()) {
      return;
   }

   const redirect = checkTournamentsAccess();

   if (redirect) {
      return navigateTo(redirect);
   }
});
